import { create } from "zustand";
import type { PaymentOrder } from "../types/cash";

interface PaymentOrderState {
  orders: Map<string, PaymentOrder>;
  setSnapshot: (data: PaymentOrder[]) => void;
  applyDelta: (upsert: PaymentOrder[], removed: string[]) => void;
}

export const usePaymentOrderStore = create<PaymentOrderState>((set, get) => ({
  orders: new Map(),
  setSnapshot: (data) => {
    const m = new Map<string, PaymentOrder>();
    for (const o of data) m.set(o.order_id, o);
    set({ orders: m });
  },
  applyDelta: (upsert, removed) => {
    const next = new Map(get().orders);
    for (const id of removed) next.delete(id);
    for (const o of upsert) next.set(o.order_id, o);
    set({ orders: next });
  },
}));

export function selectOrdersArray(s: PaymentOrderState): PaymentOrder[] {
  return Array.from(s.orders.values());
}
